module.exports = __webpack_public_path__ + "img/thothai_blue-p-500.3c8056f4.png";